import { jsx as _jsx } from "react/jsx-runtime";
import Tooltip from '@jetbrains/ring-ui/components/tooltip/tooltip';
import { format } from 'date-fns';
import { TooltipDelays } from '@common/constants/constants';
export function AuditLogsAction({ readableName, description, createdDate }) {
    const title = `${readableName} at ${format(createdDate, 'HH:mm')}`;
    return (_jsx(Tooltip, { title: title, delay: TooltipDelays.NORMAL, children: description }));
}
